import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeComponent from '../HomeComponent.vue'
import whaleLoginComponent from '../panel/whaleLoginComponent.vue'
import coolSchoolLoginComponent from '../panel/coolSchoolLoginComponent.vue'
import ChathessLoginComponent from '@/panel/chathessLoginComponent.vue'
import AiepLoginComponent from '@/panel/aiepLoginComponent.vue'
import SangsangLogin from '@/views/SangsangLogin.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeComponent
  },
  {
    path: '/whale/:code',
    name: 'whale',
    component: whaleLoginComponent
  },
  {
    path: '/coolschool/:key',
    name: 'coolschool',
    component: coolSchoolLoginComponent
  },
  {
    path: '/chathess',
    name: 'chathess',
    component: ChathessLoginComponent
  },
  {
    path: '/login/aiep',
    name: 'aiep',
    component: AiepLoginComponent
  },
  {
    path: '/sangsang/login',
    name: 'sangsang',
    component: SangsangLogin
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
